import moment from "moment";
import { ReactNode, useEffect } from "react";
import AuthHeader from "../components/auth-header";
import { useDispatch } from "react-redux";
import { setGeolocation } from "@/store/slices/authSlice";

interface AuthLayoutProps {
  children: ReactNode;
}

const footer = {
  version: `${__APP_VERSION__} - ${import.meta.env.VITE_ENV}`,
  build: __APP_BUILD_TIME__,
};

const AuthLayout = ({ children }: AuthLayoutProps) => {
  const dispatch = useDispatch();

  // Get geolocation coordinates when component mounts
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          console.log('Geolocation obtained:', { latitude, longitude });
          
          // Store coordinates in Redux
          dispatch(setGeolocation({ latitude, longitude }));
        },
        (error) => {
          console.error('Error getting geolocation:', error.message);
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 10000 }
      );
    } else {
      console.error('Geolocation is not supported by this browser');
    }
  }, [dispatch]);

  return (
    <div className="h-screen flex relative">
      <div className="flex-1 flex flex-col overflow-hidden">
        <AuthHeader />
        <div className="overflow-y-auto">
          <div className="relative overflow-auto bg-[url('/images/hero-bg.png')] bg-cover bg-center">
            <div className="flex-1 flex flex-row min-h-[calc(100vh-254px)]">
              {/* Left side with logo and illustration - now visible on all screens */}
              <div className="flex-1 p-4 md:p-8 flex-col items-center justify-center relative hidden lg:block">
                {/* Logo and illustration on Medium and larger screens */}
                <div className="hidden md:flex flex-1 flex-col items-center justify-center h-full">
                  <img
                    src={"/images/students_bg.png"}
                    alt="Time tracking illustration"
                    className="z-5 ml-[150px]"
                  />
                </div>
              </div>

              {/* Right side with form */}
              <div className="flex-1 flex items-center justify-around p-4 md:p-8 z-10">
                <div className="hidden lg:block" />
                <div className="w-full max-w-[400px]">{children}</div>
              </div>
            </div>
            {/* Version and build timestamp */}
            <div className="w-full gap-2 text-[10px] text-white z-5">
              <div className="flex justify-between items-end p-6 text-white text-sm w-full">
                <div className="flex flex-col sm:flex-row items-center gap-2">
                  <span>musictemple.in</span>
                  <div className="text-[12px] opacity-50">
                    Version: {footer.version}
                  </div>
                  <div className="text-[12px] opacity-50">
                    Build: {moment(footer.build).format("DD-MM-YYYY HH:mm")}
                  </div>
                </div>

                <img src={"/images/footer_logo.png"} alt="Gamaka Box Logo" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;
